import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import LazyLoad from "vanilla-lazyload";

export default class Utils {
    constructor()
    {
        Utils.click();
        Utils.tooltip();
        Utils.popover();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.block_cover();
        Utils.obfuscation();
        Utils.hidding_nav();
        Utils.isotope();
        Utils.show_more();
        Utils.switch();
    }

    static click()
    {

        const trigger = '[data-trigger="wpiris-click"]';

        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    ctrl = true;
                }
            } );
            $( window ).on( 'keyup', function () {
                ctrl = false;
            } );

            $( document ).on( 'mouseup', trigger, function ( e ) {

                if ( e.target.tagName.toLowerCase() !== 'a' ) {
                    if ( e.which == 1 || e.which == 2 ) {
                        let classe = $( this ).find( "a" ).attr( "class" );
                        if ( 'sliderNav' != classe ) {
                            let blank = false;
                            let url   = $( this ).find( "a" ).attr( "href" );
                            if ( e.which == 2 ) {
                                blank = true;
                            } // Clic molette
                            if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                                blank = true;
                            }
                            if ( blank || ctrl ) {
                                window.open( url, '_blank' );
                            } else {
                                window.location = url;
                            }
                            return false;
                        }
                    }
                }
                return false;

            } );
        } else {
            $( document ).on( 'click', trigger, function ( e ) {
                let classe = $( this ).find( "a" ).attr( "class" );
                if ( 'sliderNav' != classe ) {
                    let blank = false;
                    let url   = $( this ).find( "a" ).attr( "href" );
                    if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                        blank = true;
                    }
                    if ( blank ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                }

            } );
        }
    }

    static tooltip()
    {
        $( '[data-toggle="tooltip"], [rel="tooltip"]' ).tooltip( { trigger: "hover" } );
    }

    static popover()
    {
        $( '[data-toggle="popover"], [rel="popover"]' ).popover();
    }

    static fancybox()
    {

        $( '.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).attr( 'data-fancybox', 'fancybox' );

        $( '[data-fancybox="fancybox"]' ).fancybox( {
                                                        buttons: [
                                                            "zoom",
                                                            "slideShow",
                                                            "close"
                                                        ],
                                                        lang: "fr",
                                                        i18n: {
                                                            fr: {
                                                                CLOSE: Theme.translate.fancyboxClose,
                                                                NEXT: Theme.translate.fancyboxNext,
                                                                PREV: Theme.translate.fancyboxPrev,
                                                                ERROR: Theme.translate.fancyboxError,
                                                                PLAY_START: Theme.translate.fancyboxStart,
                                                                PLAY_STOP: Theme.translate.fancyboxStop,
                                                                FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                                                                THUMBS: Theme.translate.fancyboxThumbs,
                                                                DOWNLOAD: Theme.translate.fancyboxDownload,
                                                                SHARE: Theme.translate.fancyboxShare,
                                                                ZOOM: Theme.translate.fancyboxZoom
                                                            },
                                                        },
                                                        caption: function ( instance, item ) {
                                                            let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html();

                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'title' );
                                                            }

                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'alt' );
                                                            }

                                                            return caption;
                                                        }
                                                    } );
    }

    static searchbox()
    {
        const trigger  = '[data-trigger="wpiris-search-layout"]',
              close    = '[data-trigger="wpiris-search-layout-close"]',
              $element = $( '[data-id="wpiris-search-layout"]' );

        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.fadeIn().find( 'input' ).focus();
        } );

        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.fadeOut();
        } );
    }

    static smooth_scroll()
    {
        const trigger = '[data-trigger="wpiris-scroll"]';

        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();

            const target     = $( this ).attr( "href" ) != '' ? $( this ).attr( "href" ) : $( this ).attr( "data-href" ),
                  duration   = 1000,
                  scroll_top = $( target ).offset().top - (undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0);

            $( 'html, body' ).animate( {
                                           scrollTop: scroll_top
                                       }, {
                                           duration: duration,
                                           step: ( now, fx ) => {
                                               let real_pos = scroll_top;
                                               if ( fx.end !== real_pos ) {
                                                   fx.end = real_pos;
                                               }
                                           }
                                       } );
        } );
    }

    static lazy()
    {
        let lazyLoadInstance = new LazyLoad( {
                                                 elements_selector: '[data-src], [data-bg]'
                                             } );
    }

    static block_cover()
    {
        $( '.wp-block-cover:has(.wp-block-cover__inner-container a)' ).attr( 'data-trigger', 'wpiris-click' );
    }

    static obfuscation()
    {
        let element = "[data-obf]";
        if ( $( element ).length > 0 ) {
            if ( !Modernizr.touchevents ) {
                let ctrl = 0;
                $( window ).on( 'keydown', function ( e ) {
                    if ( e.which == 17 || e.which == 91 ) {
                        ctrl = true;
                    }
                } );
                $( window ).on( 'keyup', function () {
                    ctrl = false;
                } );

                $( document ).on( 'mouseup', element, function ( e ) {
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( e.which == 1 || e.which == 2 ) {
                        let blank = false;
                        if ( e.which == 2 ) {
                            blank = true;
                        } // Clic molette
                        if ( target == "_blank" ) {
                            blank = true;
                        }
                        if ( blank || ctrl ) {
                            window.open( url, '_blank' );
                        } else {
                            window.location = url;
                        }
                        return false;
                    }

                    return false;

                } );
            } else {
                $( document ).on( 'click', element, function ( e ) {
                    let blank  = false;
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( target == "_blank" ) {
                        blank = true;
                    }
                    if ( blank ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                } );
            }
        }
    }

    static hidding_nav()
    {
        let last_scroll_top = 0;
        $( window ).on( 'load scroll', function () {

            let scroll_top = $( this ).scrollTop();
            let $navbar    = $( '[data-id="wpiris-navbar"]' );
            let $header    = $( '.header' );

            if ( scroll_top >= last_scroll_top && scroll_top > $navbar.outerHeight() ) {
                // Down
                $( 'body' ).addClass( 'navbar-is-hidden' );
            } else {
                // Up
                $( 'body' ).removeClass( 'navbar-is-hidden' );
            }

            last_scroll_top = scroll_top;
        } );
    }

    static isotope()
    {
        let grid             = document.querySelector( '[data-isotope-grid]' ),
            item             = '[data-isotope-item]',
            gutterSize       = 40,
            gutterSizeMobile = 20,
            stamp            = '[data-isotope-stamp]';

        if ( $( item ).length > 1 ) {

            if ( window.matchMedia( "(max-width: 1000px)" ).matches ) {
                gutterSize = gutterSizeMobile;
            }

            if ( document.body.contains( grid ) && (window.matchMedia( "(min-width: 370px)" ).matches) ) {

                $( window ).load( function () {
                    setTimeout( function () {
                        let iso = new Isotope( grid, {
                            stamp: stamp,
                            masonry: {
                                itemSelector: item,
                                gutter: gutterSize,
                            }
                        } );
                    }, 200 );
                } );
            }
        }
    }

    static show_more()
    {
        let trigger = "[data-trigger='wpiris-show-more']";
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            let attr = $( this ).attr( 'href' );
            $( attr ).toggleClass( 'show' );
            $( this ).hide();
        } );
    }

    static switch()
    {
        const trigger     = '[data-trigger="wpiris-switch"]',
              trigger_ode = '[data-switch-value]';
        let new_value     = 0;

        if ( trigger.length > 0 ) {
            $( document ).on( 'click', trigger, function ( e ) {
                e.preventDefault();
                let value = $( this ).attr( 'data-switch-active' );
                $( this ).toggleClass( 'switch--checked' );

                if ( 0 == value ) {
                    $( this ).attr( 'data-switch-active', 1 );
                    new_value = 1;

                } else {
                    $( this ).attr( 'data-switch-active', 0 );
                    new_value = 0;
                }

                $( document ).trigger( 'wpiris-switch-click', {
                    value: new_value,
                } );
            } );
        }

        if ( trigger_ode.length > 0 && trigger.length > 0 ) {
            $( document ).on( 'click', trigger_ode, function ( e ) {
                e.preventDefault();
                let value = $( this ).attr( 'data-switch-value' );
                $( trigger ).attr( 'data-switch-active', value );

                if ( 0 == value ) {
                    $( trigger ).removeClass( 'switch--checked' );
                } else {
                    $( trigger ).addClass( 'switch--checked' );
                }

                $( document ).trigger( 'wpiris-switch-click', {
                    value: value,
                } );
            } );
        }
    }
}
